import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = {
  key: 0,
  class: "align-center"
}
const _hoisted_6 = {
  key: 1,
  class: "text-center"
}
const _hoisted_7 = {
  key: 2,
  class: "text-center"
}
const _hoisted_8 = {
  key: 3,
  class: "text-center"
}
const _hoisted_9 = {
  key: 4,
  class: "text-center"
}
const _hoisted_10 = {
  key: 5,
  class: "text-center"
}
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "align-center" }
const _hoisted_15 = {
  key: 0,
  class: "align-center"
}
const _hoisted_16 = {
  key: 1,
  class: "align-center"
}
const _hoisted_17 = {
  key: 2,
  class: "text-center"
}
const _hoisted_18 = {
  key: 3,
  class: "text-center"
}
const _hoisted_19 = {
  key: 4,
  class: "text-center"
}
const _hoisted_20 = {
  key: 5,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ColumnCorrespondence = _resolveComponent("ColumnCorrespondence")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    flat: "",
    style: {"max-width":"1000px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event)),
        touchless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_UploadDocuments, {
                showFirstPrevious: false,
                documentType: 'PRODUCTS',
                inExtensions: ['csv', 'tsv', 'txt', 'xlsx', 'xls'],
                multiple: false,
                freeTag: false,
                gDrive: true,
                onFileInput: _ctx.onFileChanged,
                onFileDeleted: _ctx.onFileDeleted,
                onTestFileInput: _ctx.onTestFileChanged
              }, null, 8, ["onFileInput", "onFileDeleted", "onTestFileInput"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 1 }, {
            default: _withCtx(() => [
              (_ctx.step > 0 && _ctx.existingFile)
                ? (_openBlock(), _createBlock(_component_ColumnCorrespondence, {
                    key: 0,
                    ref: "columnComponent",
                    result: _ctx.result,
                    extension: _ctx.extension,
                    actions: _ctx.actions,
                    ruleManager: _ctx.ruleManager,
                    formatColumns: _ctx.formatColumns,
                    onColumnsChosen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChosenColumns($event))),
                    onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.step = 0))
                  }, null, 8, ["result", "extension", "actions", "ruleManager", "formatColumns"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                headers: _ctx.importedHeaders,
                items: _ctx.importedItems,
                class: "table",
                "fixed-header": "",
                density: "compact",
                loading: _ctx.verifLoading,
                "items-per-page-options": [10, 25, 50]
              }, _createSlots({ _: 2 }, [
                (_ctx.documentType === 'INVOICE_PRODUCTS')
                  ? {
                      name: "item",
                      fn: _withCtx(({ item, index }) => [
                        _createElementVNode("tr", {
                          style: _normalizeStyle(
                                'background-color:' + item.colorAlert + '; pointer-events: none'
                            )
                        }, [
                          _createElementVNode("td", _hoisted_1, _toDisplayString(item.reference), 1),
                          _createElementVNode("td", _hoisted_2, _toDisplayString(item.title), 1),
                          _createElementVNode("td", _hoisted_3, _toDisplayString(item.unitPrice), 1),
                          _createElementVNode("td", _hoisted_4, _toDisplayString(item.vatRate), 1),
                          (_ctx.salesAccountableAccounts.length > 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                                _createVNode(_component_v_select_filled, {
                                  "hide-details": "",
                                  density: "compact",
                                  style: {"pointer-events":"auto"},
                                  modelValue: item.accountableAccountId,
                                  "onUpdate:modelValue": ($event: any) => ((item.accountableAccountId) = $event),
                                  items: _ctx.salesAccountableAccounts,
                                  "item-title": "description",
                                  "item-value": "id",
                                  class: "py-1"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                              ]))
                            : (_ctx.salesAccountableAccounts.length === 1)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(_ctx.salesAccountableAccounts[0].description), 1))
                              : (_openBlock(), _createElementBlock("td", _hoisted_7)),
                          (item.status === 'EXISTING_PRODUCT')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_8, " Le produit sera mis à jour "))
                            : (item.status === 'NEW_PRODUCT')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                                  _createVNode(_component_v_icon, {
                                    icon: "$fa-check",
                                    color: "green"
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_10, [
                                  _createVNode(_component_v_progress_circular, {
                                    indeterminate: "",
                                    color: "primary"
                                  })
                                ]))
                        ], 4)
                      ]),
                      key: "0"
                    }
                  : (_ctx.documentType === 'STOCK_PRODUCTS')
                    ? {
                        name: "item",
                        fn: _withCtx(({ item, index }) => [
                          _createElementVNode("tr", {
                            style: _normalizeStyle(
                                'background-color:' + item.colorAlert + '; pointer-events: none'
                            )
                          }, [
                            _createElementVNode("td", _hoisted_11, _toDisplayString(item.reference), 1),
                            _createElementVNode("td", _hoisted_12, _toDisplayString(item.title), 1),
                            _createElementVNode("td", _hoisted_13, _toDisplayString(item.unitPrice), 1),
                            _createElementVNode("td", _hoisted_14, [
                              _createVNode(_component_v_select_filled, {
                                "hide-details": "",
                                outlined: "",
                                density: "compact",
                                style: {"pointer-events":"auto"},
                                modelValue: item.type,
                                "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                                items: [
                                        { type: 'PRODUCT', description: 'Produit' },
                                        { type: 'EXPENSE', description: 'Achat' },
                                    ],
                                "item-title": "description",
                                "item-value": "type"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            (item.type === 'PRODUCT')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                                  _createVNode(_component_v_select_filled, {
                                    "hide-details": "",
                                    density: "compact",
                                    style: {"pointer-events":"auto"},
                                    modelValue: item.accountableAccountId,
                                    "onUpdate:modelValue": ($event: any) => ((item.accountableAccountId) = $event),
                                    items: _ctx.salesAccountableAccounts,
                                    "item-title": "description",
                                    "item-value": "id",
                                    class: "py-1"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                ]))
                              : (item.type === 'EXPENSE')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                    _createVNode(_component_v_select_filled, {
                                      "hide-details": "",
                                      density: "compact",
                                      style: {"pointer-events":"auto"},
                                      modelValue: item.accountableAccountId,
                                      "onUpdate:modelValue": ($event: any) => ((item.accountableAccountId) = $event),
                                      items: _ctx.purchaseAccountableAccounts,
                                      "item-title": "description",
                                      "item-value": "id",
                                      class: "py-1"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                  ]))
                                : (_openBlock(), _createElementBlock("td", _hoisted_17)),
                            (item.status === 'EXISTING_PRODUCT')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_18, " Le produit sera mis à jour "))
                              : (item.status === 'NEW_PRODUCT')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                                    _createVNode(_component_v_icon, {
                                      icon: "$fa-check",
                                      color: "green"
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("td", _hoisted_20, [
                                    _createVNode(_component_v_progress_circular, {
                                      indeterminate: "",
                                      color: "primary"
                                    })
                                  ]))
                          ], 4)
                        ]),
                        key: "1"
                      }
                    : undefined
              ]), 1032, ["headers", "items", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}